export enum StepNames {
  DiscountForm = 'discountForm',
  PromoCodeForm = 'promoCodeForm',
  AssociationsForm = 'associationsForm',
  Summary = 'summary',
}
